import { isPeriodWorklogKpiId, PERIOD_WORKLOG_KPI_IDS } from './pmoReportScope';

export type PmoKpiConfig = {
  id: string;
  title?: string;
};

export const insertKpiConfig = (items: PmoKpiConfig[], kpiId: string): PmoKpiConfig[] => {
  if (items.some((item) => item.id === kpiId)) return items;
  const nextItem: PmoKpiConfig = { id: kpiId };
  if (!isPeriodWorklogKpiId(kpiId)) {
    return [...items, nextItem];
  }
  const periodOrder = PERIOD_WORKLOG_KPI_IDS as readonly string[];
  const periodItems = [...items.filter((item) => isPeriodWorklogKpiId(item.id)), nextItem]
    .sort((a, b) => periodOrder.indexOf(a.id) - periodOrder.indexOf(b.id));
  const classicItems = items.filter((item) => !isPeriodWorklogKpiId(item.id));
  const afterReal = classicItems.findIndex((item) => item.id === 'hh_real_total');
  if (afterReal >= 0) {
    return [
      ...classicItems.slice(0, afterReal + 1),
      ...periodItems,
      ...classicItems.slice(afterReal + 1),
    ];
  }
  return [...classicItems, ...periodItems];
};

export const toggleKpiConfig = (items: PmoKpiConfig[], kpiId: string): PmoKpiConfig[] => (
  items.some((item) => item.id === kpiId)
    ? items.filter((item) => item.id !== kpiId)
    : insertKpiConfig(items, kpiId)
);

/** Mantém espaços enquanto o usuário digita o título personalizado. */
export const draftKpiTitle = (
  items: PmoKpiConfig[],
  kpiId: string,
  title: string,
): PmoKpiConfig[] => (
  items.map((item) => (
    item.id === kpiId
      ? { ...item, title }
      : item
  ))
);

/** Trim só ao sair do campo; título vazio volta ao rótulo padrão. */
export const commitKpiTitle = (
  items: PmoKpiConfig[],
  kpiId: string,
  title: string,
): PmoKpiConfig[] => {
  const nextTitle = title.trim();
  return items.map((item) => (
    item.id === kpiId
      ? { ...item, title: nextTitle || undefined }
      : item
  ));
};

export const extractPeriodKpiIds = (items: PmoKpiConfig[]): string[] => (
  items.filter((item) => isPeriodWorklogKpiId(item.id)).map((item) => item.id)
);

export const reorderKpiConfigs = (
  items: PmoKpiConfig[],
  sourceId: string,
  targetId: string,
): PmoKpiConfig[] => {
  if (sourceId === targetId) return items;
  const sourceIndex = items.findIndex((item) => item.id === sourceId);
  const targetIndex = items.findIndex((item) => item.id === targetId);
  if (sourceIndex < 0 || targetIndex < 0) return items;
  const next = [...items];
  const [moved] = next.splice(sourceIndex, 1);
  next.splice(targetIndex, 0, moved);
  return next;
};
